import * as React from 'react';
import Popover from '@material-ui/core/Popover';

const CustomPopover = (props) => {
    return <Popover {...props} />;
};

export { CustomPopover as Popover };
